export const environment = {
  config: false,
  baseUrlAdminApi: 'https://vmomlt-aps-test-we-frontend-02.azurewebsites.net/',
  baseUrlPowerBIApi: 'vmomlt-aps-demo-we-apivnext-powerbi-01.azurewebsites.net',
  release: 'natasha',
  production: false,
  buildNumber: '20260930.2',
  serviceWorker: false,
  googleMapsKey: 'AIzaSyAurjgjxJ_0e1gPw-9XIpa0ZJXof8cANiE',
  appinsight_instrumentationkey: '55bf795f-1f0d-4d9f-839d-afcec70205b9',
  bikeImageFallback: '/assets/map/img/libera_vaimoo.png',
  oldVersion: false,
  feature: {
    assets: {
      baseline: false,
      components: false,
    },
    services: {
      issueCategory: false,
    }
  }
}
